import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ChangePayerCommandHandler } from './change-payer-command-handler.servcice';
import { IncorrectPaymentCommand } from '../../command/incorrect-payment';
import { Injectable } from '@angular/core';
import { PayInvoiceCommandHandler } from './pay-invoice-command-handler.service';
import { VoidPaymentCommandHandler } from './void-payment-command-handler.service';
import { ContactBalanceCommandHandler } from './contact-balance-command-handler.service';
import { IncorrectPaymentExportCommandHandler } from './export-incorrect-payment-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { VoidIncorrectPaymentsCommandHandler } from './void-incorrect-payments-command-handler.service';

@Injectable()
export class IncorrectPaymentCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    changePayer: ChangePayerCommandHandler,
    payInvoice: PayInvoiceCommandHandler,
    customerBalance: ContactBalanceCommandHandler,
    incorrectPaymentExportHandler: IncorrectPaymentExportCommandHandler,
    voidPayment: VoidPaymentCommandHandler,
    editIncorrectPayment: EditCommandHandler,
    voidIncorrectPayments: VoidIncorrectPaymentsCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.export, incorrectPaymentExportHandler);
    this.addHandler(IncorrectPaymentCommand.changePayer, changePayer);
    this.addHandler(IncorrectPaymentCommand.payInvoice, payInvoice);
    this.addHandler(IncorrectPaymentCommand.customerBalance, customerBalance);
    this.addHandler(IncorrectPaymentCommand.voidIncorrectPayments, voidIncorrectPayments);
    (this.addHandler(IncorrectPaymentCommand.voidPayment, voidPayment), this.addHandler(standardCommand.edit, editIncorrectPayment));
  }
}
